/**
 * The site's dialogs, loaded on every page by the layout: the image lightbox, the YouTube player
 * and message dialogs such as the contact form's thank-you. Each is a native <dialog> the page
 * renders; this wires up the ones present.
 */

import { startImageLightbox } from "./dialogs/image-lightbox";
import { openMessageDialog, startMessageDialog } from "./dialogs/message-dialog";
import { startYouTubePlayer } from "./dialogs/youtube-player";

const supported = (dialog: HTMLDialogElement | null): dialog is HTMLDialogElement =>
    dialog !== null && typeof dialog.showModal === "function";

// Module scripts run once the document has parsed, so the dialogs are in the DOM.
const lightbox = document.querySelector<HTMLDialogElement>("dialog[data-image-lightbox]");
if (supported(lightbox)) {
    startImageLightbox(lightbox);
}
const youTube = document.querySelector<HTMLDialogElement>("dialog[data-youtube-dialog]");
if (supported(youTube)) {
    startYouTubePlayer(youTube);
}
for (const dialog of document.querySelectorAll<HTMLDialogElement>("dialog[data-message-dialog]")) {
    if (supported(dialog)) {
        startMessageDialog(dialog);
    }
}

// The legacy scripts (Scripts/v1/contactForm.js) open message dialogs through this.
(window as unknown as { openMessageDialog: typeof openMessageDialog }).openMessageDialog =
    openMessageDialog;
